import Event from '../../core/Event';
import { FilterToRemove } from '../../core/arrayOperations';

export default class EstimationsFilterRemoved extends Event {
    public static type = 'EstimationsFilterRemoved';

    constructor(public readonly filter: FilterToRemove) {
        super(EstimationsFilterRemoved.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/order/events/EstimationsFilterRemoved.ts